let domParser: DOMParser | null = null;

export const processDomNodes =
  ({
    selector,
    domAction,
  }: {
    selector: string;
    domAction: (e: Element) => void;
  }) =>
  (domString: string) => {
    if (!domParser) {
      try {
        domParser = new DOMParser();
      } catch {
        // this should be supported by most browsers:
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
        // but if now, just display what was there before.
        return domString;
      }
    }
    const doc = domParser.parseFromString(domString, 'text/html');
    if (!doc) {
      return domString;
    }

    const nodes = doc.querySelectorAll(selector);
    nodes.forEach((element) => domAction(element));
    return doc.body ? doc.body.innerHTML : domString;
  };
